import CircleIcon from "@redotech/redo-icons/circle_filled.svg";
import CropIcon from "@redotech/redo-icons/crop-01_filled.svg";
import ImageHorizontalIcon from "@redotech/redo-icons/image-left_filled.svg";
import ImageVerticalIcon from "@redotech/redo-icons/image-up_filled.svg";
import LockIcon from "@redotech/redo-icons/lock-01_filled.svg";
import UnlockIcon from "@redotech/redo-icons/lock-unlocked-01_filled.svg";
import SquareIcon from "@redotech/redo-icons/square_filled.svg";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { IconButton } from "../../../../button";
import { Flex } from "../../../../flex";
import { Text } from "../../../../text";
import { AspectRatioOption } from "./image-editor-modal";
import { ImageEditorModalLeftRailItem } from "./image-editor-modal-left-rail-item";
import * as styles from "./image-editor-modal-left-rail.module.css";

interface Props {
  aspectRatio: AspectRatioOption;
  selectAspectRatio: (aspectRatio: AspectRatioOption) => void;
  width: number;
  height: number;
  setWidth: (width: number) => void;
  setHeight: (height: number) => void;
  lockAspectRatio: boolean;
  setLockAspectRatio: (lock: boolean) => void;
}

export const ImageEditorModalLeftRail = ({
  aspectRatio,
  selectAspectRatio,
  width,
  height,
  setWidth,
  setHeight,
  lockAspectRatio,
  setLockAspectRatio,
}: Props) => {
  return (
    <Flex className={styles.container} dir="column" gap="md">
      <Flex dir="column" gap="sm">
        <ImageEditorModalLeftRailItem
          Icon={CropIcon}
          isActive={aspectRatio === "custom"}
          label="Custom"
          onClick={() => {
            selectAspectRatio("custom");
          }}
        />
        <ImageEditorModalLeftRailItem
          Icon={ImageHorizontalIcon}
          isActive={aspectRatio === "16:9"}
          label="16:9 Rectangle"
          onClick={() => {
            selectAspectRatio("16:9");
          }}
        />
        <ImageEditorModalLeftRailItem
          Icon={ImageHorizontalIcon}
          isActive={aspectRatio === "4:3"}
          label="4:3 Rectangle"
          onClick={() => {
            selectAspectRatio("4:3");
          }}
        />
        <ImageEditorModalLeftRailItem
          Icon={ImageVerticalIcon}
          isActive={aspectRatio === "3:4"}
          label="3:4 Rectangle"
          onClick={() => {
            selectAspectRatio("3:4");
          }}
        />
        <ImageEditorModalLeftRailItem
          Icon={ImageVerticalIcon}
          isActive={aspectRatio === "2:3"}
          label="2:3 Rectangle"
          onClick={() => {
            selectAspectRatio("2:3");
          }}
        />
        <ImageEditorModalLeftRailItem
          Icon={SquareIcon}
          isActive={aspectRatio === "1:1"}
          label="1:1 Square"
          onClick={() => {
            selectAspectRatio("1:1");
          }}
        />
        <ImageEditorModalLeftRailItem
          Icon={CircleIcon}
          isActive={aspectRatio === "circle"}
          label="Circle"
          onClick={() => {
            selectAspectRatio("circle");
          }}
        />
      </Flex>

      {/* Dimensions section */}
      <Flex align="flex-end" dir="row" gap="md" mt="md">
        <Flex dir="column" gap="xs">
          <Text fontSize="sm">Width</Text>
          <RedoTextInput
            className={styles.inputWidth}
            inputTypeHint="number"
            placeholder="Width"
            setValue={(n) => setWidth(parseInt(n))}
            size="sm"
            value={width.toString()}
          />
        </Flex>

        <Flex dir="column" gap="xs">
          <Text fontSize="sm">Height</Text>
          <RedoTextInput
            className={styles.inputWidth}
            inputTypeHint="number"
            placeholder="Height"
            setValue={(n) => setHeight(parseInt(n))}
            size="sm"
            value={height.toString()}
          />
        </Flex>

        <Flex align="flex-end" dir="column" gap="xs">
          <IconButton
            onClick={() => {
              const newLockState = !lockAspectRatio;
              setLockAspectRatio(newLockState);

              if (!newLockState) {
                selectAspectRatio("custom");
              }
            }}
          >
            {lockAspectRatio ? <LockIcon /> : <UnlockIcon />}
          </IconButton>
        </Flex>
      </Flex>
    </Flex>
  );
};
